import { render, staticRenderFns } from "./EditCompareciente.vue?vue&type=template&id=8a1b800a&scoped=true"
import script from "./EditCompareciente.vue?vue&type=script&lang=js"
export * from "./EditCompareciente.vue?vue&type=script&lang=js"
import style0 from "./EditCompareciente.vue?vue&type=style&index=0&id=8a1b800a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b800a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1b800a')) {
      api.createRecord('8a1b800a', component.options)
    } else {
      api.reload('8a1b800a', component.options)
    }
    module.hot.accept("./EditCompareciente.vue?vue&type=template&id=8a1b800a&scoped=true", function () {
      api.rerender('8a1b800a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/EditCompareciente.vue"
export default component.exports